import { connect } from 'react-redux'
import get from 'lodash/get'

import { loadActivitiesForArea, downloadCSV } from '../../actions/area-activities'

import AreaActivity from '../../components/area-activities/area-activity.js'

function mapStateToProps (state, ownProps) {
  const id = ownProps.areaId

  const area = state.areas[ownProps.areaId]
  const pagination = get(state, `pagination.activitiesByArea.${id}`, {})
  const {
    ids: activityIds = [],
    nextPageUrl: hasNextPage,
    isFetching = true
  } = pagination

  return {
    areaId: area.id,
    hasNextPage,
    activityIds,
    isFetching,
    area,
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  dispatch(loadActivitiesForArea(ownProps.areaId))

  return {
    onLoadNextPage () {
      dispatch(loadActivitiesForArea(ownProps.areaId, true))
    },
    onDownloadCSV (area) {
      dispatch(downloadCSV(area.id, area))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AreaActivity)



// WEBPACK FOOTER //
// ./src/containers/area-activities/area-activity-container.js